import { Form, Input, Divider } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import {
  FormItemReduced,
  FormItemMedium,
  FormItemNoMargin,
  LinkButton,
  FullWidthButton,
} from './styles/LoginFormStyles'
import { GoogleSignInButton } from './GoogleSignInButton'
import { LinkedInSignInButton } from './LinkedInSignInButton'

interface LoginFormProps {
  onFinish: (values: { email: string; password: string }) => void
  onForgotPassword: () => void
  loading: boolean
}

export function LoginForm({ onFinish, onForgotPassword, loading }: LoginFormProps) {
  const [form] = Form.useForm()

  return (
    <Form
      form={form}
      name="login"
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      size="large"
    >
      <Form.Item
        name="email"
        rules={[
          { required: true, message: 'Please input your email!' },
          { type: 'email', message: 'Please enter a valid email!' },
        ]}
      >
        <Input prefix={<UserOutlined />} placeholder="Email" autoComplete="email" />
      </Form.Item>

      <FormItemReduced
        name="password"
        rules={[
          { required: true, message: 'Please input your password!' },
          { min: 6, message: 'Password must be at least 6 characters!' },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="Password"
          autoComplete="current-password"
        />
      </FormItemReduced>

      <FormItemMedium>
        <LinkButton type="link" onClick={onForgotPassword}>
          Forgot password?
        </LinkButton>
      </FormItemMedium>

      <FormItemNoMargin>
        <FullWidthButton type="primary" htmlType="submit" loading={loading}>
          Sign In
        </FullWidthButton>
      </FormItemNoMargin>

      <Divider plain>or</Divider>

      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <GoogleSignInButton label="Google" />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <LinkedInSignInButton label="LinkedIn" />
        </div>
      </div>
    </Form>
  )
}
